import React, { FunctionComponent, useLayoutEffect } from 'react';
import './App.less';
import { BrowserRouter } from 'react-router-dom';
import Routes from 'Routes/console';
import { ConfirmationModalContainer } from 'Components/confirmation-modal';
import { GlobalLoadingContainer } from 'Components/global-loading-container';
import { ToastContainer } from 'Components/toast-container';
import { AuthenticationService } from 'Services/AuthenticationService';
import { useService } from 'Hooks';

const App: FunctionComponent = () => {
    const authenticationService = useService(AuthenticationService);
    useLayoutEffect(() => {
        authenticationService.installInterceptors();
    }, [authenticationService]);
    return (
        <>
            <BrowserRouter>
                <Routes />
            </BrowserRouter>
            <ConfirmationModalContainer />
            <ToastContainer />
            <GlobalLoadingContainer />
        </>
    );
};

export default App;
